<template>
  <v-row>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.reminders.retrieveLoader" transition="fade-transition" type="article" />
      <template v-else>
        <v-card>
          <v-toolbar color="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Branding</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <span class="d-block body-1 text--secondary font-weight-medium">Elementos de diseño</span>
              </v-col>
              <v-col cols="4">
                <span class="body-1 text--secondary font-weight-medium">Logo</span>
                <v-sheet class="mt-3">
                  <input ref="editable.logo" type="file" accept="image/png" style="display:none" @change="getLogoPreview">
                  <v-btn v-if="!logoPreview && !editable.logo" @click="$refs['editable.logo'].click()" outlined color="secondary"><v-icon>mdi-plus</v-icon></v-btn>
                  <v-hover v-if="logoPreview || editable.logo" v-slot:default="{hover}">
                    <v-img :loading="logoPreview" :aspect-ratio="4" contain class="rounded" :src="logoPreview ? logoPreview : editable.logo" @click="$refs['editable.logo'].click()" max-width="200" min-height="90" style="border:1px solid #D8E0EA;">
                      <v-expand-transition>
                        <div v-if="hover" class="d-flex transition-fast-in-fast-out background v-card--reveal primary--text font-weight-medium" style="cursor:pointer; height:100%;">Seleccionar</div>
                      </v-expand-transition>
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular size="30" indeterminate color="blue lighten-4" />
                        </v-row>
                      </template>
                    </v-img>
                  </v-hover>
                </v-sheet>
              </v-col>
              <v-col cols="2">
                <span class="body-1 text--secondary font-weight-medium">Color principal</span>
                <v-sheet class="mt-3" width="140">
                  <v-text-field v-model="$v.editable.color_background.$model" reverse background-color="white" outlined required single-line dense hide-details>
                    <template v-slot:append>
                      <v-menu v-model="menu" bottom :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                          <div :style="swatchStyle" v-on="on" />
                        </template>
                        <v-card>
                          <v-card-text class="pa-0">
                            <v-color-picker v-model="$v.editable.color_background.$model" flat width="250" />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-sheet>
              </v-col>
              <v-col cols="2">
                <span class="body-1 text--secondary font-weight-medium">Color secundario</span>
                <v-sheet class="mt-3" width="140">
                  <v-text-field :value="editable.color_asset" reverse background-color="white" outlined required single-line dense hide-details>
                    <template v-slot:append>
                      <v-menu v-model="menu1" bottom :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                          <div :style="swatchStyle1" v-on="on" />
                        </template>
                        <v-card>
                          <v-card-text class="pa-0">
                            <v-color-picker v-model="$v.editable.color_asset.$model" flat width="250" />
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <span class="d-block body-1 text--secondary font-weight-medium">Diseño de correo electrónico</span>
              </v-col>
              <v-col cols="3" v-for="d in emailTemplates" :key="d">
                <v-sheet @click="editable.email_template = d" style="cursor: pointer">
                  <v-radio-group v-model="editable.email_template" :mandatory="false" class="py-0 mt-0 rounded" style="border: 1px solid #D8E0EA">
                    <v-img class="rounded" cover :aspect-ratio="0.8" :src="require(`@/assets/appAsset-Branding--TemplateEmail-${d}.svg`)" />
                    <v-radio class="px-3 pt-4 pb-0" :value="d" :label="d | capitalize" />
                  </v-radio-group>
                </v-sheet>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-text class="background">
            <v-row>
              <v-col cols="3">
                <span class="d-block body-1 text--secondary font-weight-medium">Previsualización</span>
              </v-col>
              <v-col cols="9">
                <v-card class="overflow-hidden" outlined>
                  <v-card-title class="pa-0">
                    <v-tabs v-model="previewTabs" color="primary" height="48" slider-size="2">
                      <v-tab class="text-none font-weight-medium" :ripple="false">Emails</v-tab>
                      <v-tab class="text-none font-weight-medium" :ripple="false">Portal de pagos</v-tab>
                    </v-tabs>
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="py-6">
                    <v-tabs-items class="transparent" v-model="previewTabs">
                      <v-tab-item transition="fade-transition" reverse-transition="fade-transition">
                        <v-row align="start" justify="center">
                          <v-col cols="7">
                            <reminder-invoice-email :instance="previewReminderTemplate" action="pay" :template="editable.email_template" :color-background="editable.color_background" :color-asset.sync="editable.color_asset" />
                          </v-col>
                        </v-row>
                      </v-tab-item>
                      <v-tab-item transition="fade-transition" reverse-transition="fade-transition">
                        <v-row align="start" justify="center">
                          <v-col cols="7">
                            <payment-portal :instance="previewPaymentPortal" :color-background="editable.color_background" :logo="logoPreview ? logoPreview : editable.logo" />
                          </v-col>
                        </v-row>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn @click="patchAccount" :loading="$store.state.accounts.createLoader" color="primary">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import ReminderInvoiceEmail from '@/components/reminders/invoices/Email'
import PaymentPortal from '@/components/payments/PaymentPortal'
import PaymentList from '../../components/payments/PaymentList.vue'
export default {
  components: {
    ReminderInvoiceEmail,
    PaymentPortal,
    PaymentList
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    radios: 'radio-1',
    modes: ['hsla', 'rgba', 'hexa'],
    menu: false,
    menu1: false,
    previewReminderTemplate: {
      customer: {
        name: 'Acme Inc'
      },
      date: '2021-01-01',
      document: {
        name: 'Invoice'
      },
      currency: 'USD',
      number: 17743,
      total: 186.00
    },
    previewPaymentPortal: {
      amount: 186.00,
      currency: 'USD',
      date: '2021-01-01',
      gateways: ['stripe', 'twocheckout']
    },
    emailTemplates: ['classic', 'modern', 'admiral'],
    logoPreview: '',
    editable: {
      logo: '',
      email_template: '',
      color_background: '',
      color_asset: ''
    },
    previewTabs: 0
  }),
  computed: {
     swatchStyle () {
      return {
        backgroundColor: this.$v.editable.color_background.$model,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px'
      }
    },
    swatchStyle1 () {
      return {
        backgroundColor: this.$v.editable.color_asset.$model,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px'
      }
    },
     ...mapState({
      accountsDetail: state => state.accounts.accountsDetail
    })
  },
  created () {
    this.$store.dispatch('accounts/RETRIEVE', {
      resource: 'accounts',
      id: this.account.id
    })
    .then(() => {
      this.editable = {
        logo: this.accountsDetail.logo,
        email_template: this.accountsDetail.email_template,
        color_background: this.accountsDetail.color_background,
        color_asset: this.accountsDetail.color_asset
      }
    })
  },
  methods: {
    patchAccount () {
      this.editable.logo = this.$refs['editable.logo'].files[0]
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }
      const payload = new FormData()
      if (this.editable.logo) {
        payload.append('logo', this.editable.logo, this.editable.logo.name)
      }
      payload.append('email_template', this.editable.email_template)
      payload.append('color_background', this.editable.color_background)
      payload.append('color_asset', this.editable.color_asset)
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: payload,
        id: this.accountsDetail.id,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then((response) => {
        this.$store.commit('auth/SET_ACCOUNT', { account: response.data, redirect: false })
        this.editable = {
          logo: response.data.logo,
          email_template: response.data.email_template,
          color_background: response.data.color_background,
          color_asset: response.data.color_asset
        }
        this.$dialog.message.info('La información de la organización se ha actualizado')
        this.resetLogoField()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    getLogoPreview (e) {
      if (e.target.files.length) {
        this.logoPreview = URL.createObjectURL(e.target.files[0])
      } else {
        this.logoPreview = ''
      }
    },
    resetLogoField () {
      this.$refs['editable.logo'].type = 'text'
      this.$refs['editable.logo'].type = 'file'
      this.logoPreview = ''
    }
  },
  validations: {
    editable: {
      email_template: {
        required
      },
      color_background: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(7)
      },
      color_asset: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(7)
      }
    }
  }
}
</script>
<style scoped>
::v-deep .v-text-field .v-input__append-inner {
  padding-left: 3px !important;
  margin-top: 3px !important;
  margin-bottom: 2px !important;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
</style>